import { createBrowserRouter } from 'react-router-dom';
import ProtectedRoute from './ProtectedRoute';
import MainLayout from '../views/MainLayout';
import Dashboard from '../views/MainLayout/components/Dashboard';
import Ajustes from '../views/MainLayout/components/Ajustes';
import Clientes from '../views/MainLayout/components/Clientes';
import ClienteSheet from '../views/MainLayout/components/Clientes/components/ClienteSheet';
import Devoluciones from '../views/MainLayout/components/Devoluciones';
import DevolucionContainer from '../views/MainLayout/components/Devoluciones/components/DevolucionContainer';
import DevolucionMercancias from '../views/MainLayout/components/DevolucionMercancias';
import Envios from '../views/MainLayout/components/Envios';
import Finanzas from '../views/MainLayout/components/Finanzas';
import PiezasReservadas from '../views/MainLayout/components/PiezasReservadas';
import Vehiculos from '../views/MainLayout/components/Vehiculos';
import Ventas from '../views/MainLayout/components/Ventas';
import Comerciales from '../views/MainLayout/components/Comerciales';
import Facturas from '../views/MainLayout/components/Facturas';
import FacturasDesguaces from '../views/MainLayout/components/FacturasDesguaces';
import NotasCargo from '../views/MainLayout/components/NotasCargo';
import Incidencias from '../views/MainLayout/components/Incidencias';
import FichaIncidencia from '../views/MainLayout/components/Incidencias/components/FichaIncidencia';
import Bastidores from '../views/MainLayout/components/Bastidores';
import Presupuestos from '../views/MainLayout/components/Presupuestos';
import FichaPresupuesto from '../views/MainLayout/components/Presupuestos/components/FichaPresupuesto';
import Proveedores from '../views/MainLayout/components/Proveedores';
import ProveedorSheet from '../views/MainLayout/components/Proveedores/components/ProveedorSheet';
import Users from '../views/MainLayout/components/Users';
import UserDetail from '../views/MainLayout/components/Users/components/UserDetail';
import RecordatoriosClientes from '../views/MainLayout/components/RecordatoriosClientes';
import Account from '../views/MainLayout/components/Account';
import TecDoc from '../views/MainLayout/components/TecDoc';

export const router = createBrowserRouter([
    {
        path: '/',
        element: 
            <ProtectedRoute>
                <MainLayout />
            </ProtectedRoute>
        ,
        children: [
            { path: '/', element: <Dashboard /> },
            { path: '*', element: <Dashboard /> },
            { path: 'ajustes', element: <Ajustes /> },
            { path: 'clientes/:page', element: <Clientes /> },
            { path: 'cliente/:clienteId', element: <ClienteSheet /> },
            { path: 'comerciales/:page', element: <Comerciales /> },
            { path: 'devoluciones/:page', element: <Devoluciones /> },
            { path: 'devolucion/:devolucionId', element: <DevolucionContainer /> },
            { path: 'devoluciones-mercancias/:page', element: <DevolucionMercancias /> },
            { path: 'envios/:page', element: <Envios /> },
            { path: 'facturas/:page', element: <Facturas /> },
            { path: 'facturas-desguaces/:page', element: <FacturasDesguaces /> },
            { path: 'notas-cargo/:page', element: <NotasCargo /> },
            { path: 'finanzas', element: <Finanzas /> },
            { path: 'incidencias/:page', element: <Incidencias /> },
            { path: 'incidencia/:incidenciaId', element: <FichaIncidencia /> },
            { path: 'matriculas/:page', element: <Bastidores /> },
            { path: 'mi-cuenta', element: <Account /> },
            { path: 'piezas-reservadas', element: <PiezasReservadas /> },
            { path: 'presupuestos/:page', element: <Presupuestos /> },
            { path: 'presupuesto/:presupuestoId', element: <FichaPresupuesto /> },
            { path: 'proveedores/:page', element: <Proveedores /> },
            { path: 'proveedor/:proveedorId', element: <ProveedorSheet /> },
            { path: 'recordatorios', element: <RecordatoriosClientes /> },
            { path: 'tecdoc/:page', element: <TecDoc /> },
            { path: 'users/:page', element: <Users /> },
            { path: 'user/:userId', element: <UserDetail /> },
            { path: 'vehiculos/:page', element: <Vehiculos /> },
            { path: 'ventas/:page', element: <Ventas /> }
        ]
    }
]);
